// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { CameraFeedback, type ICameraFeedback, type IDeviceData } from '.';

export interface ICaptureState {
  feedback: ICameraFeedback;
  capturing: boolean;
  captured: boolean;
  deviceData: IDeviceData | null;
}

export class CaptureState implements ICaptureState {
  public feedback: ICameraFeedback;
  public capturing: boolean;
  public captured: boolean;
  public deviceData: IDeviceData | null;

  constructor(feedback?: ICameraFeedback, capturing = false, captured = false, deviceData: IDeviceData | null = null) {
    this.feedback = feedback ?? new CameraFeedback('');
    this.capturing = capturing;
    this.captured = captured;
    this.deviceData = deviceData;
  }
}
